export const DEFAULT_IMG_CACHE_TIME = 120000
export const DEFAULT_VIDEO_CACHE_TIME = 120000
export const DEFAULT_AUDIO_CACHE_TIME = 120000
export const DEFAULT_DOCUMENT_CACHE_TIME = 120000
export const DEFAULT_POST_IN_HIGH_CACHE_TIME = 3600000

export const ERROR_CODE_MESSAGE = {
  BANNED_USER: 'SPACE_GATEWAY_092'
}
